export function ttfb() {
	new PerformanceObserver((entryList) => {
		const [pageNav] = entryList.getEntriesByType('navigation');

		console.log(`TTFB: ${pageNav.responseStart}`);
	}).observe({type: 'navigation', buffered: true});
}
